import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router }                       from '@angular/router';
import { MatProgressSpinner }                           from '@angular/material/progress-spinner';
import { Observable }                                   from 'rxjs';

import { StringUtils }           from '../../../shared/utils/string.utils';
import { AuthenticationService } from '../../../core/auth/authentication.service';
import { LoginResult }           from '../../../core/auth/data/login-result';
import { GrantType }             from '../../../core/auth/sso.service';

@Component({
  selector: 'pin-sso-login',
  templateUrl: './sso-login.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [MatProgressSpinner]
})
export class SsoLoginComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private authService = inject(AuthenticationService);
  isLoading = true;

  ngOnInit(): void {
    this.loginWithSsoIfApplicable();
  }

  private loginWithSsoIfApplicable(): void {
    let loginObservable: Observable<LoginResult>;
    const queryParams = this.activatedRoute?.snapshot?.queryParams || {};
    const authorizationCode = queryParams.code;
    const pingAppName = queryParams.app;

    if (document.location.hash.startsWith('#')) {
      const hashParams = StringUtils
        .parseKeyValuePairs(document.location.hash.substring(1), '&');

      if (hashParams?.id_token !== undefined && authorizationCode) {
        loginObservable = this.authService.ssoLogin(authorizationCode, pingAppName, GrantType.CODE);
      }
    } else if (authorizationCode) {
      loginObservable = this.authService.ssoLogin(authorizationCode, pingAppName, GrantType.CODE);
    }

    if (!loginObservable) {
      return;
    }

    loginObservable.subscribe(() => {
      this.router.navigate(['/']).then();
    });
  }
}
